import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import routes from './config/settings/routes'
import { Amplify } from 'aws-amplify'
import {
  REACT_APP_USER_POOL_CLIENT_ID,
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_IDENTITY_POOL_ID
} from './config/settings/environments'
import LoginPage from './pages/Login';
import HomePage from './pages/Home';
import DashboardPage from './pages/Dashboard';
import History from './pages/History';
import ProductivityPage from './pages/Productivity';
import Map from './pages/Map';
import ReportsPage from './pages/Reports';
import OrdersPage from './pages/Orders';
import CanPage from './pages/Can';
import HuellaPage from './pages/Huella';
import Kepler from './pages/Kepler';
import CyclesPage from './pages/Cycle';
import TimesPage from './pages/Time';
import RouteChangeTracker from './analytics/RouteChangeTracker';

/**
 * The Route's component.
 */

const AppRoutes = () => {
  const manualAWSconfig = {
    Auth: {
      identityPoolId: REACT_APP_USER_IDENTITY_POOL_ID,
      userPoolId: REACT_APP_USER_POOL_ID,
      region: 'us-east-1',
      userPoolWebClientId: REACT_APP_USER_POOL_CLIENT_ID
    }
  }
  Amplify.configure(manualAWSconfig)

  return (
    <BrowserRouter>
      <RouteChangeTracker />
      <History>
        <Switch>
          <Route exact path={routes.home} component={HomePage} />
          <Route exact path={routes.login} component={LoginPage} />
          <Route exact path={routes.dashboard} component={DashboardPage} />
          <Route exact path={routes.map} component={Map} />
          <Route exact path={routes.reports} component={ReportsPage} />
          <Route exact path={routes.productivity} component={ProductivityPage} />
          <Route exact path={routes.orders} component={OrdersPage} />
          <Route exact path={routes.can} component={CanPage} />
          <Route exact path={routes.huella} component={HuellaPage} />
          <Route exact path={routes.kepler} component={Kepler} />
          <Route exact path={routes.cycles} component={CyclesPage} />
          <Route exact path={routes.times} component={TimesPage} />
        </Switch>
      </History>
    </BrowserRouter>
  )
}

export default AppRoutes